import { _ACTIVITIES, _ROLES_BACK } from "../../utils/constants";
import { BaseBudgetInput } from "../../components/budget/BaseBudgetInput";
import { Table } from "../../components/budget/hire-equipment/Table";
import { _ROUTES } from "../../utils/_routes_constants";
import { useEffect, useState } from "react";
import {
  HIRE_OF_EQUIPMENT_INCOME,
  LINKED_HIRE_EQUIPMENT_DATA,
  OTHER_SUNDRY_EXPS,
  SAVE_CATEGORY_HIRE_EQUIPMENT,
} from "../../utils/savedDataConstant/hireEquipmentSaveConstants";
import { sendToFinancialData } from "../../components/budget/BaseBudgetSaveFunctions";

export const InputHireEquipment = () => {
  const [saveData, setSaveData] = useState([]);
  const arrayData = LINKED_HIRE_EQUIPMENT_DATA;
  const save_name_category = SAVE_CATEGORY_HIRE_EQUIPMENT;
  const [params, setParams] = useState({});

  useEffect(() => {
    if (saveData.length > 0) {
      const modifiedData = saveData
        ?.map((d) => {
          if (!d) return null;

          const payload = {
            activityName: _ACTIVITIES.LRU,
            siteId: params.site,
            theme: d.title,
            months: d.months,
          };

          return payload;
        })
        .filter(
          (d) =>
            d !== null &&
            (d.theme === OTHER_SUNDRY_EXPS ||
              d.theme === HIRE_OF_EQUIPMENT_INCOME),
        );

      sendToFinancialData(modifiedData, save_name_category);
    }
  }, [saveData]);

  return (
    <BaseBudgetInput
      title="Input Hire of Equipment"
      roles={[_ROLES_BACK._ROLE_ADMIN, _ROLES_BACK._ROLE_CTRL]}
      userRole={_ROLES_BACK._ROLE_IT}
      enableFlag="dataEntryEnableSales"
      TableComponent={Table}
      tableComponentProps={{
        params,
      }}
      saveData={saveData}
      setSaveData={setSaveData}
      includeBaseBudgetSave={true}
      arrayData={arrayData}
      saveNameCategory={save_name_category}
      onParamsChange={setParams}
      filters={[
        {
          key: "site",
          route: _ROUTES.SITES,
          defaultValue: "",
          label: "Site",
          queryParams: {
            active: 1,
            "activities.code": _ACTIVITIES.LRU,
          },
        },
        {
          key: "activity",
          route: _ROUTES.ACTIVITIES,
          defaultValue: "",
          label: "Activity",
          dependsOn: "site",
          queryParams: {
            active: 1,
          },
        },
      ]}
    />
  );
};
